import { siteListPath, widgetListPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'
import { Site } from '@/common/model/site'

import BackButton from '@/components/view/atoms/button/BackButton'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'

import SiteForm from '@/components/container/form/modules/admin/site/SiteForm'

interface Props {
  site?: Site
  onRefetch?: () => void
}

const SiteEditPage = ({ site, onRefetch }: Props) => {
  return (
    <>
      <Main type={site ? MainLayoutType.MEDIUM : MainLayoutType.SMALL}>
        <BackButton link={siteListPath()} />
        <SiteForm site={site} onRefetch={onRefetch} />
      </Main>
    </>
  )
}

export default SiteEditPage
